// German fallbacks for system saved-filter labels that are not in the backend translation file.
// That file is regenerated from the admin portal, so keys added there locally do not survive.
const PERIOD_ACTIVITY_FALLBACKS = {
  'saved_filters.system.employees_inactive_in_period': 'Beschäftigte, die in dieser Periode inaktiv sind',
  'saved_filters.system.employees_active_in_period': 'Beschäftigte, die in dieser Periode aktiv sind',
  'saved_filters.system.balanced_scorecards_without_budget': 'Leistungskarten ohne Budget',
  'saved_filters.system.balanced_scorecards_without_group': 'Leistungskarten ohne Gruppe',
  'saved_filters.system.evaluations_without_group': 'Beurteilungen ohne Gruppe',
  'saved_filters.system.employees_assigned_to_both_modules': 'Beschäftigte, die beiden Modulen zugeordnet sind',
  'saved_filters.system.assignment_candidates_previously_in_module': 'Berechtigte frühere Modulbeschäftigte ohne Zuordnung zu dieser Periode',
  'saved_filters.system.assignment_candidates_new_to_module': 'Berechtigte Beschäftigte, die neu in diesem Modul sind',
  'filters.period_activity': 'Aktivität in dieser Periode',
  'filter.period_activity.active': 'Aktiv',
  'filter.period_activity.inactive': 'Inaktiv',
  'filters.assigned_modules': 'Zugeordnete Module',
  'filters.period_imported_at': 'In diese Periode importiert am',
  'filters.number_of_regular_evaluations': 'Anzahl der Regelbeurteilungen',
  'action.type.assign_to_period': 'Periode zuweisen',
  'action.detail.assign_to_period.title': 'Beschäftigte der Periode zuweisen',
  'action.detail.assign_to_period.scope.previously_in_module': 'Bereits früher diesem Modul zugeordnet',
  'action.detail.assign_to_period.scope.new_to_module': 'Neu in diesem Modul',
  'action.detail.assign_to_period.empty': 'Keine berechtigten Beschäftigten für diese Zuweisung gefunden.',
  'action.detail.assign_to_period.invalid_context': 'Die Zielperiode oder der Kandidatenbereich fehlt.',
  'action.detail.assign_to_period.success': 'Beschäftigte wurden der Periode zugewiesen.',
};

export const periodActivityTranslationFallback = (translationKey, fallback = null) => (
  PERIOD_ACTIVITY_FALLBACKS[translationKey] ?? fallback
);

export { PERIOD_ACTIVITY_FALLBACKS };
